// Config
export const AXIOS_TIMEOUT = 300000;

// Trigger / Retrigger
export const PRELAUNCH_TRIGGER_LOADING = 'PRELAUNCH/TRIGGER_LOADING';
export const PRELAUNCH_TRIGGER_SUCCESS = 'PRELAUNCH/TRIGGER_SUCCESS';
export const PRELAUNCH_TRIGGER_ERROR = 'PRELAUNCH/TRIGGER_ERROR';
export const PRELAUNCH_TRIGGER_CONFLICT = 'PRELAUNCH/TRIGGER_CONFLICT'; // ALREADY_RUNNING
export const PRELAUNCH_FEATURE_DISABLED = 'PRELAUNCH/FEATURE_DISABLED'; // FEATURE_DISABLED
export const PRELAUNCH_FORBIDDEN = 'PRELAUNCH/FORBIDDEN'; // FORBIDDEN / RBAC

// Status polling
export const PRELAUNCH_STATUS_LOADING = 'PRELAUNCH/STATUS_LOADING';
export const PRELAUNCH_SET_STATUS = 'PRELAUNCH/SET_STATUS';
export const PRELAUNCH_STATUS_ERROR = 'PRELAUNCH/STATUS_ERROR';

// Full report
export const PRELAUNCH_REPORT_LOADING = 'PRELAUNCH/REPORT_LOADING';
export const PRELAUNCH_SET_REPORT = 'PRELAUNCH/SET_REPORT';
export const PRELAUNCH_REPORT_ERROR = 'PRELAUNCH/REPORT_ERROR';

// Report history
export const PRELAUNCH_HISTORY_LOADING = 'PRELAUNCH/HISTORY_LOADING';
export const PRELAUNCH_SET_HISTORY = 'PRELAUNCH/SET_HISTORY';
export const PRELAUNCH_HISTORY_ERROR = 'PRELAUNCH/HISTORY_ERROR';

// Drill-down detail
export const PRELAUNCH_DETAIL_LOADING = 'PRELAUNCH/DETAIL_LOADING';
export const PRELAUNCH_SET_DETAIL = 'PRELAUNCH/SET_DETAIL';
export const PRELAUNCH_DETAIL_ERROR = 'PRELAUNCH/DETAIL_ERROR';

// Filter options
export const PRELAUNCH_SET_FILTER_OPTIONS = 'PRELAUNCH/SET_FILTER_OPTIONS';

// Download
export const PRELAUNCH_DOWNLOAD_LOADING = 'PRELAUNCH/DOWNLOAD_LOADING';
export const PRELAUNCH_DOWNLOAD_ERROR = 'PRELAUNCH/DOWNLOAD_ERROR';

// UI state
export const PRELAUNCH_SET_CAMPAIGN_ID = 'PRELAUNCH/SET_CAMPAIGN_ID';
export const PRELAUNCH_SET_ACTIVE_TAB = 'PRELAUNCH/SET_ACTIVE_TAB';
export const PRELAUNCH_RESET = 'PRELAUNCH/RESET';
